"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardTimezoneDisclaimer = void 0;

var _preact = require("preact");

var DashboardTimezoneDisclaimer = function DashboardTimezoneDisclaimer() {
  return (0, _preact.h)("div", {
    className: "dashboard-timezone-disclaimer"
  }, "This dashboard is displayed in UTC time.");
};

exports.DashboardTimezoneDisclaimer = DashboardTimezoneDisclaimer;